import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Clock, XCircle } from "lucide-react";
import { api, eur } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);
  const { clear } = useCart();
  const attempts = useRef(0);
  const polled = useRef(false);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;

    const poll = async () => {
      if (cancelled) return;
      attempts.current += 1;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") {
          setStatus("paid");
          if (!polled.current) { polled.current = true; clear(); }
          return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts.current >= 10) { setStatus("pending"); return; }
        setTimeout(poll, 2000);
      } catch (e) {
        if (attempts.current >= 5) setStatus("error");
        else setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, clear]);

  return (
    <main className="max-w-2xl mx-auto px-6 py-32 text-center" data-testid="page-payment-success">
      {status === "checking" && (
        <>
          <Clock size={48} className="mx-auto brand-primary-text mb-6" />
          <h1 className="font-serif text-4xl brand-text mb-4">A confirmar o pagamento...</h1>
          <p className="brand-muted">Por favor aguarde um instante.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 size={48} className="mx-auto text-[#4A6B53] mb-6" data-testid="payment-success-icon" />
          <h1 className="font-serif text-4xl brand-text mb-4">Obrigada pela sua compra!</h1>
          <p className="brand-muted mb-2">O seu pagamento foi confirmado com sucesso.</p>
          {info && <p className="brand-muted mb-8">Total: <strong>{eur(info.amount_total / 100)}</strong></p>}
          <div className="flex gap-3 justify-center">
            <Link to="/conta" className="btn-primary">Ver encomendas</Link>
            <Link to="/loja" className="btn-ghost">Continuar a comprar</Link>
          </div>
        </>
      )}
      {(status === "pending" || status === "expired" || status === "error") && (
        <>
          <XCircle size={48} className="mx-auto text-[#9E4747] mb-6" />
          <h1 className="font-serif text-4xl brand-text mb-4">
            {status === "expired" ? "Sessão expirada" : status === "pending" ? "Pagamento em processamento" : "Não foi possível verificar"}
          </h1>
          <p className="brand-muted mb-8">Caso o problema persista, contacte-nos por email.</p>
          <Link to="/loja" className="btn-primary">Voltar à loja</Link>
        </>
      )}
    </main>
  );
}
